import { useContext } from "react";
import GlobalContext from "../app/GlobalContext/GlobalContext";

export default function () {
  return useContext(GlobalContext);
}
